import { fetchStatusDisplayUtils } from "../../utilities/dataTableCellUtils";

export const Notifications = ({ notifications }) => {
    return (
        <div className="mb-3">
            {
                notifications && notifications.length > 0 && notifications.map(item =>
                    <div key={ item.id } className={ `d-flex align-items-center mb-3 alert alert-${ fetchStatusDisplayUtils(item.notificationType).color }` }>
                        <div>{ fetchStatusDisplayUtils(item.notificationType).icon }</div>
                        <div className="ml-2">
                            <p className="m-0 fs--1">{ item.message }</p>
                        </div>
                    </div>)
            }
        </div>
    )
}